import { Position, Toaster } from '@blueprintjs/core';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

class NotificationToaster extends PureComponent {
  static propTypes = {
    toast: PropTypes.shape({
      intent: PropTypes.string,
      message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    }),
  };

  toaster = null;

  componentDidUpdate() {
    const { toast } = this.props;
    if (toast) {
      this.showToast(toast);
    }
  }

  showToast(toast) {
    const { intent, message, icon } = toast;

    this.toaster.show({
      intent,
      message,
      icon,
      timeout: 7000,
    });
  }

  handleToasterRef = ref => {
    this.toaster = ref;
  };

  render() {
    return <Toaster position={Position.BOTTOM_LEFT} ref={this.handleToasterRef} />;
  }
}

export default connect(state => ({
  toast: state.notification.toast,
}))(NotificationToaster);
